/** Nav labels/paths for User manual (shared by `routes.ts` and `UserManualLayout`). */

export interface UserManualNavItem {
    id: string;
    label: string;
    path: string;
}

export const USER_MANUAL_NAV_ITEMS: UserManualNavItem[] = [
    { id: 'user-manual-overview', label: 'Overview', path: '/user-manual/overview' },
    { id: 'user-manual-setup', label: 'Setup', path: '/user-manual/setup' },
    { id: 'user-manual-workbench', label: 'Workbench', path: '/user-manual/workbench' },
    { id: 'user-manual-data-principals', label: 'Data Principals', path: '/user-manual/data-principals' },
    { id: 'user-manual-requests', label: 'Requests', path: '/user-manual/requests' },
    { id: 'user-manual-consents', label: 'Consents', path: '/user-manual/consents' },
    { id: 'user-manual-audit-logs', label: 'Audit Logs', path: '/user-manual/audit-logs' },
    { id: 'user-manual-notices', label: 'Notices', path: '/user-manual/notices' },
    { id: 'user-manual-collection-points', label: 'Collection points', path: '/user-manual/collection-points' },
    { id: 'user-manual-dashboard', label: 'Dashboard', path: '/user-manual/dashboard' },
    { id: 'user-manual-settings', label: 'Settings', path: '/user-manual/settings' }
];
